import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'
import format from 'date-fns/format'
import { endOfMonth } from 'date-fns'

type Props = {
  date: Date
  startMonth: Date
  endMonth: Date
  selectDate: (date: Date) => void
  isClosed: boolean
  isOrdered: boolean
  isSpecialHoliday: boolean
  isStartDate: boolean
  isEndDate: boolean
  isInPeriod: boolean
}

const RevenueCalendarCell: FC<Props> = React.memo((props) => {
  const {
    date,
    startMonth,
    endMonth,
    selectDate,
    isClosed,
    isOrdered,
    isSpecialHoliday,
    isStartDate,
    isInPeriod,
    isEndDate,
  } = props

  const isThisMonths = isSameMonth(date, startMonth) || isSameMonth(date, endMonth)

  const className = (() => {
    switch (true) {
      // 定休日が選択中の場合
      case isThisMonths && isClosed && !isOrdered && isInPeriod:
        return styles.table__cell_active_closed
      // 定休日が祝日
      case isThisMonths && isClosed && !isOrdered && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 定休日の場合（灰色セル）
      case isThisMonths && isClosed && !isOrdered:
        return styles.table__cell_disabled
      // 選択された開始日か終了日の場合
      case isThisMonths && (isStartDate || isEndDate):
        return styles.table__cell_active
      // 選択された期間内
      case isThisMonths && isInPeriod:
        return styles.table__cell_active_light
      // 当日が祝日
      case isThisMonths && isSameDay(date, new Date()) && isSpecialHoliday:
        return styles.table__cell__holiday_today
      // 当日（黄色セル）
      case isThisMonths && isSameDay(date, new Date()):
        return styles.table__cell_today
      // 通常営業日が祝日
      case isThisMonths && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  const mark = (() => {
    if (isThisMonths && isOrdered) {
      if (isStartDate || isEndDate || isInPeriod) {
        return <span className={styles.table__mark_white} />
      } else {
        return <span className={styles.table__mark} />
      }
    } else {
      return <></>
    }
  })()

  const borderMonthClass = (() => {
    const endOfFirstMonth: number = getDate(endOfMonth(startMonth))
    if (isSameMonth(date, startMonth)) {
      if (getDate(date) === endOfFirstMonth) {
        return styles.table__border_lastDate
      } else if (getDate(date) > endOfFirstMonth - 7 && getDate(date) < endOfFirstMonth) {
        return styles.table__border_lastWeek
      } else {
        return ''
      }
    } else {
      return ''
    }
  })()

  return (
    <td
      className={`${className} ${borderMonthClass}`}
      onClick={() => (isClosed && !isOrdered ? null : selectDate(date))}
    >
      <span className={styles.table__cell__date}>
        {isThisMonths ? (getDate(date) === 1 ? format(date, 'M/d') : getDate(date)) : ''}
        {mark}
      </span>
    </td>
  )
})

export default RevenueCalendarCell
